import { Application } from "pixi.js";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { ITransition } from "./ITransition";
import { ITransitionParams } from "./ITransitionFactory";
import * as PIXI from 'pixi.js';
import { CreateSpineResources, Delay, Log, LogGroup, Safe, Scale } from "../../MyHelpers";
import { Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { ISkeletonData, Spine } from "pixi-spine";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import gsap from "gsap";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { debug } from "svelte/internal";
import { Track } from "../../AudioManager";
import Jackpot from "../../AdminMenu/pages/Jackpot.page.svelte";
import { JackpotDisplayProperties } from "../../JackpotDisplayProperties";

export class TransitionAnimationSpine implements ITransition {

    protected params: ITransitionParamsPIXIAPP = null;
    protected app: PIXI.Container = null;
    protected logGroup: LogGroup = null;
    protected started: boolean = false;
    protected view: HTMLElement = null;
    protected gameName: string = "";
    protected TitlePIXIAnimatedSprite: PIXI.AnimatedSprite = null;
    protected titleSpine: Spine = null;
    protected skelentonDataSpine: ISkeletonData = null;
    protected titleTexture: PIXI.Texture[] = [];
    protected resid: ResourceIdentifier = null;
    protected jackpotName: string;

    constructor(params: ITransitionParamsPIXIAPP) {
        this.params = params;
        this.gameName = params.gameName;
        this.resid = params.resid.Add("TransitionAnimationSpine");

        this.jackpotName = Settings.JackpotDisplayType;
        if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias) this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;
    }
    ViewPIXIAPP(): PIXI.Container {
        return this.app;
    }
   public OnResize(): void {
        throw new Error("Method not implemented.");
    }
   

    public async PrepareResources(resourceManager?: IWriteOnlyResourceManager): Promise<void> {
        //Spine Prepare 				
        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/TransitionSpine/TransitionSpine.json`, this.resid.ScopedResourceName(`TransitionAnimationSpineJSON`)));
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/TransitionSpine/TransitionSpine.atlas`, this.resid.ScopedResourceName(`TransitionAnimationSpineATLAS`)));

        if (this.params.bonusName == "FreeGameBonus") {
            //create Title Freegames Spine
            resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`)));
            resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleAtlas`)));
            //Prepare Sound Transition Title 
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }
        else {
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/" + this.jackpotName + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }

        //if (!globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton() && this.params.bonusName != "FreeGameBonus") resourceManager.AddGlobal(new SpriteResource(this.params.bonusCommonPath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/" + this.jackpotName + "_Transition", ResourceIdentifier.Global.Add("TitleTransition").Add(this.params.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.params.bonusName), true))

    }

    protected jsonSpine: ISkeletonData = null;
    public async ResourcesLoaded(resourceManager?: IReadOnlyResourceManager): Promise<void> {
        let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`TransitionAnimationSpineJSON`));
        let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
        this.jsonSpine = spineAsset.spineData;



        if (!globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton()) {
            let spriteResource = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.params.bonusName))
            for (let decodedFrames of spriteResource?.sprite.shared.decodedFrames) {
                

                // baseTexture.width = this.textureSize.width;
                //baseTexture.height = this.textureSize.height;

                let symbolTexture = PIXI.Texture.from(decodedFrames);
                this.titleTexture.push(symbolTexture);
            }
        }
        //its using title for jackpot into spine version.
        else {
            //check which bonus was creating the transition for change the title spine.
            if (this.params.bonusName == "FreeGameBonus") {
                let spineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`));
                let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
                this.skelentonDataSpine = spineAsset.spineData;
            } else {
                this.skelentonDataSpine = globalThis.jackpotDisplayGlobal.GetSpineSkeleton();
            }
        }
    }

    public ShowTransiton(): void {
        if (this.started == false) {

            this.spine.state.setAnimation(0, "animation", false);
            this.started = true;

            if (this.titleSpine != null) gsap.to(this.titleSpine, {
                duration: 1, alpha: 1, onComplete: () => {
                    this.titleSpine.state.setAnimation(0,"idle", false);
                     this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                    //this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                }
            });
            if (this.TitlePIXIAnimatedSprite != null) gsap.to(this.TitlePIXIAnimatedSprite, {
                duration: 1, alpha: 1, onComplete: () => {
                    //this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                }
            });

           

            if (this.titleSpine != null) gsap.to(this.titleSpine, { duration: 0.5, alpha: 0 })
            if (this.TitlePIXIAnimatedSprite != null) gsap.to(this.TitlePIXIAnimatedSprite, { duration: 0.5, alpha: 0 })
            setTimeout(() => {               
                this.OnTransitionEnded()
            }, 3000);
        }
    }
    public View(): HTMLElement {
        return null
        //return new HTMLElement();
    }
    public Update(): void {

    }

    public onTransitionStart: () => void = null;
    public onTransitionEnd: () => void = null;

    protected created: boolean = false;
    public CreateTransitionPixi(app: PIXI.Container) {
        this.app = app;
        this.Create();
    };

    public DestroyTransitionPixi() {    
        //this.Destroy()
        //this.updateMatter = false;
        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
            return;
        }        
        


        Safe(() => { this.titleSpine?.state?.clearTracks() })
        Safe(() => { this.titleSpine?.state?.clearListeners() })
        Safe(() => { this.titleSpine?.destroy(); })
        Safe(() => { this.containertransitionViewApp.removeChild(this.titleSpine); });
        Safe(() => { this.TitlePIXIAnimatedSprite?.removeFromParent() })
        Safe(() => { this.spine?.state?.clearTracks(); })
        Safe(() => { this.spine?.state?.clearListeners(); });
        Safe(() => { this.containertransitionViewApp.removeChild(this.spine); });
        //Safe(() => { this.spine?.destroy() })  
        Safe(() => {
            this.containertransitionViewApp?.removeFromParent();
        });
        Safe(() => {
            this.containertransitionViewApp?.destroy();
        });
       
    };

    public Create() {
        this.created = true;
        {
            this.InternalCreate();
        }
    }

    protected containertransitionViewApp: PIXI.Container = null;
    protected spine: Spine = null;
    public InternalCreate() {
        if (!this.created) {
            Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
            return;
        }

        if (this.app == null) return


        this.containertransitionViewApp = new PIXI.Container();
        this.containertransitionViewApp.name = "containertransitionViewApp";
        this.containertransitionViewApp.interactive = false;       
        this.containertransitionViewApp.interactiveChildren = false;
        this.app.addChild(this.containertransitionViewApp);
        this.containertransitionViewApp.zIndex = 1;
        this.containertransitionViewApp.parent.setChildIndex(this.containertransitionViewApp, 1);



        this.spine = CreateSpineResources(this.jsonSpine);
        if(Settings.Screens == 2) this.spine.y = Scale.Y(-1080);
        this.spine?.state?.addListener({
            complete: async () => {
                await Delay(1);
                this.DestroyTransitionPixi();
            },
            start: () =>{
                //await Delay(1);
                this.OnTransitionStarted();
            }
        });
        this.containertransitionViewApp.addChild(this.spine);


        if (this.skelentonDataSpine != null) {
            this.titleSpine = CreateSpineResources(this.skelentonDataSpine);
            gsap.set(this.titleSpine, { duration: 0.2, alpha: 0 });
            this.titleSpine.y = Settings.ScreenHeight * (Settings.Screens - 1);
            this.containertransitionViewApp.addChild(this.titleSpine);
        }
        else {
            this.TitlePIXIAnimatedSprite = new PIXI.AnimatedSprite(this.titleTexture);
            //this.TitlePIXIAnimatedSprite.x = Settings.ScreenWidth/2;
            gsap.set(this.TitlePIXIAnimatedSprite, { duration: 0.2, alpha: 0 });
            this.TitlePIXIAnimatedSprite.y = (Settings.ScreenHeight * (Settings.Screens - 1)) + (this.TitlePIXIAnimatedSprite.height / 2);
            this.TitlePIXIAnimatedSprite.alpha = 0;
            this.containertransitionViewApp.addChild(this.TitlePIXIAnimatedSprite);
        }
    }

    public OnTransitionStarted() {
        Log.Debug(this.logGroup, "Transition started");
        this.onTransitionStart?.();
    }

    public OnTransitionEnded(): void {
        Log.Debug(this.logGroup, "Transition ended");
        this.started = false;
        this.onTransitionEnd?.();
    }
}